import type { ReactNode } from "react";
import logo from "../img/ntfy-filled.svg";

interface AvatarBoxProps {
  children?: ReactNode;
}

const AvatarBox = (props: AvatarBoxProps) => (
  <div className="mx-auto flex h-dvh w-[min(400px,90dvw)] flex-col items-center justify-center p-6">
    <div className="bg-card text-card-foreground shadow-card w-full rounded-2xl p-6">
      <img src={logo} alt="ntfy" className="bg-primary-soft mb-4 size-14 rounded-2xl p-2.5" />
      {props.children}
    </div>
  </div>
);

export default AvatarBox;
